// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { CompleteAttribute } from './CompleteAttribute';
import { BEDistributedTransaction } from './BEDistributedTransaction';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 分布式事务属性 实体类
 * 分布式事务属性
 */
export class DTAttribute extends CompleteAttribute {
  /** 分布式事务 的ID */
  private _distributedTransaction_ID: string;

  /** 获取：分布式事务 的ID */
  public get distributedTransaction_ID() {
    return this._distributedTransaction_ID;
  }

  /** 设置：分布式事务 的ID */
  public set distributedTransaction_ID(value: string) {
    this._distributedTransaction_ID = value;
  }

  /** 分布式事务  */
  private _distributedTransaction: BEDistributedTransaction;

  /** 获取：分布式事务  */
  public get distributedTransaction() {
    return this._distributedTransaction;
  }

  /** 设置：分布式事务  */
  public set distributedTransaction(value: BEDistributedTransaction) {
    this._distributedTransaction = value;
    if (value !== null) {
      this.distributedTransaction_ID = value.id;
    } else {
      this.distributedTransaction_ID = '';
    }
  }

  constructor() {
    super();
    this._distributedTransaction_ID = '';
    this._distributedTransaction = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: DTAttribute, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.distributedTransaction_ID = element.distributedTransaction_ID;
      if (hasReference && element.distributedTransaction !== null) {
        this.distributedTransaction = element.distributedTransaction;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.distributedTransaction_ID = json.DistributedTransaction_ID;
    // if (json.DistributedTransaction !== null) {
    //   this.distributedTransaction = BEDistributedTransaction.Create(json.DistributedTransaction);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.DistributedTransaction_ID = this.distributedTransaction_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): DTAttribute {
    const dTAttribute = new DTAttribute();
    dTAttribute.Deserialize(json);
    dTAttribute.json = json;
    return dTAttribute;
  }
}
